import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  page: {
    padding: '40px 0 60px',
    background: colors.backgroundColor,

    [breakpoints.down(650)]: {
      padding: '0',
      background: '#FFF',
    },
  },
  formWrapper: {
    maxWidth: '100%',

    [breakpoints.down('xs')]: {
      height: '100%',
    },
  },
  form: {
    width: '100%',
    height: '100%',
    maxWidth: '616px',
    background: '#fff',
    padding: '60px 106px 40px',

    [breakpoints.down(650)]: {
      padding: '20px 30px 0 30px',
    },
  },
  title: {
    marginBottom: 16,
    fontSize: 24,
    fontFamily: 'Montserrat, sans-serif',
    textAlign: 'center',
  },
  tip: {
    fontSize: 16,
    fontFamily: 'Roboto',
    textAlign: 'center',
  },
  topTip: {
    marginBottom: 40,
  },
  bottomTip: {
    marginTop: 24,
  },
  submitButtonRoot: {
    marginTop: 23,
    width: '100%',
    minWidth: 'unset',
    height: '34px',
    padding: '0 12px 0 11px',
    color: palette.buttonAction.color,
    background: palette.buttonAction.background,
    '&:disabled': {
      color: '#FFF',
    },
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
    [breakpoints.down('xs')]: {
      marginTop: 15,
    },
  },
  submitButtonLabel: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontWeight: 800,
    textTransform: 'none',
  },
  breakLine: {
    margin: '22px 16px 0',
    width: '100%',
    color: '#515B6A',
  },
  cardField: {
    flexBasis: '30%',
  },
  spinnerWrapper: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2147483100,
  },
  dialog: {
    '& .MuiPaper-root': {
      width: '100%',
      maxWidth: '628px',
    },
  },
  fullCardNumberField: {
    marginBottom: 32,
  },
}), { name: 'PlanCheckout' });

export default useStyles;
